import { ModuleFE_AIPrompt } from './ModuleFE_AIPrompt.js';
export const ModulePackFE_AIPrompt = [ModuleFE_AIPrompt];
//# sourceMappingURL=module-pack.js.map